import {
  clearAgentDetailsFromStorage,
  clearLoginRequestFromStorage,
  clearMemberDetailsFromStorage,
  clearModeFromStorage,
  clearSessionFromStorage,
  clearTokenFromStorage,
  clearFeatureFlagsFromStorage,
  clearBulkReferral,
  clearDeclinedScreener,
  clearIdentifiedNeeds,
  clearCheckDisableScreening,
  clearVendor,
  clearsaveFromSearch
} from '@src/utills/storage';
import React, { useEffect } from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';

export const LogOut = () => {
  useEffect(() => {
    clearSessionFromStorage();
    clearLoginRequestFromStorage();
    clearTokenFromStorage();
    clearModeFromStorage();
    clearMemberDetailsFromStorage();
    clearAgentDetailsFromStorage();
    clearFeatureFlagsFromStorage();
    clearBulkReferral();
    clearDeclinedScreener();
    clearIdentifiedNeeds();
    clearCheckDisableScreening();
    clearsaveFromSearch();
    clearVendor();
  }, []);

  return (
    <React.Fragment>
      <div>
        <Heading
          serif
          level={1}
          color="#002677"
          style={{
            top: '50%',
            position: 'absolute',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          You have been successfully logged out. You can close this window now.
        </Heading>
      </div>
    </React.Fragment>
  );
};
